import React from 'react';
import { func, node } from 'prop-types';
import classNames from 'classnames';
import { getRenderable } from '@fiverr-private/fit';
import { BASE_CLASS } from './constants';
import NewBadge from './NewBadge';

import './index.scss';

const EducationBox = ({
    title,
    body,
    badgeTitle,
    closeTitle,
    onClose
}) => {
    const wrapperClasses = classNames(
        BASE_CLASS,
        'tbody-6'
    );

    return (
        <div className={wrapperClasses}>
            <header>
                <strong>{getRenderable(title)}</strong>
                {badgeTitle && <NewBadge className="new-badge" title={badgeTitle}/>}
            </header>
            <section>
                <p>{getRenderable(body)}</p>
            </section>
            <footer>
                <button onClick={onClose}>
                    <strong>{closeTitle}</strong>
                </button>
            </footer>
        </div>
    );
};

EducationBox.propTypes = {
    /**
     * The presented tooltip title
     */
    title: node,
    /**
     * The presented tooltip body
     */
    body: node,
    /**
     * The presented tooltip badge title
     */
    badgeTitle: node,
    /**
     * The presented tooltip close button title
     */
    closeTitle: node,
    /**
     * A callback function triggered when the box is closed.
     * Receives one argument - the event that caused the close cycle.
     */
    onClose: func
};

export default EducationBox;
